import { useMemo, useState } from "react"
import { debounce } from "lodash"

import { UITypes } from "types"

import { TableSearchContent } from "./TableSearchContent"

interface SimpleTableSearchProps {
  headerCell: UITypes.TableHeaderCell
}

export const SimpleTableSearch = ({ headerCell }: SimpleTableSearchProps) => {
  const { name, title, onSearch } = headerCell
  const [searchValue, setSearchValue] = useState("")

  const debouncedOnSearch = useMemo(
    () =>
      debounce((value: string) => {
        onSearch?.(value)
      }, 150),
    [onSearch],
  )

  const handleClear = () => {
    setSearchValue("")
    debouncedOnSearch.cancel()
    onSearch?.("")
  }

  const handleInputChange = (value: string) => {
    setSearchValue(value)
    debouncedOnSearch(value.trim())
  }

  return (
    <TableSearchContent
      name={name}
      label={title}
      value={searchValue}
      onClear={handleClear}
      onInputChange={handleInputChange}
    />
  )
}
